import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect, useMemo } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Layout from "./layout";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { alpha } from "@mui/material/styles";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import FeePayment from "./FeePayment";
import StorePurchase from "./StorePurchase";
import StorePayment from "./StorePayment";
import TransportPayment from "./TransportPayment";
import AnnualSubscription from "./AnnualSubscription";
import Refund from "./Refund";
import InventoryRefund from "./InventoryRefund";
import PaymentSummary from "./PaymentSummary";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import axios from "axios";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import "../App.css";
import { CircularProgress } from "@mui/material";
import { useAcademicYear } from "./AcademicYearContext";
import { Autocomplete } from "@mui/material";
import { getInstituteConfig } from "../utility/instituteConfig";

export default function FeesReport() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  // Applied search term — only changes when the user submits it via the Go
  // button or Enter, at which point the fetch effect (which depends on it)
  // fires exactly once for that action.
  const [appliedSearch, setAppliedSearch] = useState("");
  const [pendingFees, setPendingFees] = useState(false);
  const [gradeName, setGradeName] = useState("");
  const [feesSlabName, setFeesSlabName] = useState("");
  const [feesReport, setFeesReport] = useState([{}]);
  const [grades, setGrades] = useState([{}]);
  const [feesSlab, setFeesSlab] = useState([{}]);
  const [gradeId, setGradeId] = useState(undefined);
  const [feesSlabId, setFeesSlabId] = useState(undefined);
  // Picking a grade/section/fee slab/pending-fees no longer applies it
  // immediately — gradeId/sectionId/feesSlabId/pendingFees reflect whatever
  // is currently picked in the controls, but the fetch only uses these
  // applied* values, which are set (along with the search term) when Go is
  // clicked. That lets every filter be combined into one applied fetch.
  const [appliedGradeId, setAppliedGradeId] = useState(undefined);
  const [appliedSectionId, setAppliedSectionId] = useState(undefined);
  const [appliedFeesSlabId, setAppliedFeesSlabId] = useState(undefined);
  const [appliedPendingFees, setAppliedPendingFees] = useState(false);
  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState(undefined);
  const [feesSlabAmount, setFeesSlabAmount] = useState(undefined);
  const [refundBalance, setRefundBalance] = useState("");
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("student_id");
  const [currentPendingAmount, setCurrentPendingAmount] = useState(0);
  const [remark, setRemark] = useState("");
  const [getGrade, setGetGrade] = useState("");
  const [displayedFeesReport, setDisplayedFeesReport] = useState([]); // Filtered data to display
  const [userId, setUserId] = useState();
  const [sections, setSections] = useState([]);
  const [sectionName, setSectionName] = useState("");
  const [getSection, setGetSection] = useState("");
  const [sectionId, setSectionId] = useState(undefined);
  const [transportslabId, setTransportSlabId] = useState(undefined);
  const [transportSlab, setTransportSlab] = useState(undefined);
  const [userMail, setUserMail] = useState();
  const [loading, setLoading] = useState(false); // Loading state

  const rows = displayedFeesReport;
  const navigate = useNavigate();
  const { academicYearId } = useAcademicYear();
  const { selectedYear } = useAcademicYear();

  const [dues, setDues] = useState([]);
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  const currentAcademicYear = `${currentYear}-${nextYear}`;
  const instituteId = localStorage.getItem("instituteId");
  const getDues = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/feesReport/getDues",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            academic_year_id: academicYearId,
          }),
        },
      );

      const data = await response.json();
      if (data) {
        setDues(data);
      }
    } catch (error) {
      console.error("Error fetching fees report data:", error);
    }
  };

  useEffect(() => {
     if (!academicYearId) return;
    getDues();
  }, [academicYearId]);

  useEffect(() => {
    console.log("Received Academic Year ID:", academicYearId);
  }, [academicYearId]);

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } },
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
          setUserMail(response.data.user.email_id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_JHS_DEVELOPMENT + "/grade/grade-section", {
        withCredentials: true,
      })
      .then((response) => {
        const sortedSections = response.data.sections.sort((a, b) =>
          a.section_name.localeCompare(b.section_name),
        );
        setSections(sortedSections);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin");
        } else {
          console.error("Error fetching grades:", error);
        }
      });
  }, []);

  const navigateToStorePayment = () => {
    setValue(2);
  };

  // Just updates what's selected in the dropdown — doesn't apply it.
  // Applying (along with search/other filters) happens on Go.
  const handleSectionChange = (event) => {
    const value = event.target.value;
    setSectionName(value);
    if (value === "") {
      setSectionId(undefined); // "All"
      return;
    }
    const selectedSection = sections.find((fr) => fr.section_name === value);
    setSectionId(selectedSection?.section_id);
  };

  const handleGradeChange = (event) => {
    const value = event.target.value;
    setGradeName(value);
    if (value === "") {
      setGradeId(undefined); // "All"
      return;
    }
    const selectedGrade = grades.find((fr) => fr.grade_name === value);
    setGradeId(selectedGrade?.grade_id);
  };

  const handleFeesSlabChange = (event) => {
    const value = event.target.value;
    setFeesSlabName(value);
    if (value === "") {
      setFeesSlabId(undefined); // "All"
      return;
    }
    const selectedFeesSlab = feesSlab.find((fs) => fs.fees_slab === value);
    setFeesSlabId(selectedFeesSlab?.fees_slab_id);
  };

  const handlePendingFeesChange = () => {
    setPendingFees(!pendingFees);
  };

  // Every filter here is explicit now: typing a search term, picking a
  // grade/section/fee slab, or toggling Pending Fees does nothing on its
  // own. Only clicking Go (or pressing Enter in the search box) applies
  // whichever combination is currently set, all together, in one fetch.
  const handleApplyFilters = () => {
    setAppliedSearch(search.trim());
    setAppliedGradeId(gradeId);
    setAppliedSectionId(sectionId);
    setAppliedFeesSlabId(feesSlabId);
    setAppliedPendingFees(pendingFees);
    setPage(0); // Reset to first page since the filtered result set changes
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      handleApplyFilters();
    }
  };

  // Clears the search box AND applies that immediately (rather than
  // waiting for Go/Enter) — the whole point of the clear button is to get
  // straight back to the unfiltered-by-search list without an extra click.
  // Grade/Section/Fee Slab/Pending Fees stay as they were; only the search
  // scope resets.
  const handleClearSearch = () => {
    setSearch("");
    setAppliedSearch("");
    setPage(0);
  };

  useEffect(() => {
    getFeesReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [academicYearId, appliedGradeId, appliedFeesSlabId, appliedSectionId, appliedPendingFees, page, rowsPerPage, appliedSearch, orderBy, order]);

  useEffect(() => {
    getGrades();
  }, []);

  useEffect(() => {
    getFeesSlab();
  }, []);

  // Holds full page results already fetched this session, keyed by the
  // exact filter+page combo, so navigating back to a page already seen
  // skips the network entirely. TTL-bounded below since a payment recorded
  // from the dialog changes pending/paid amounts server-side without
  // otherwise invalidating this cache.
  const pageCacheRef = React.useRef(new Map());
  const PAGE_CACHE_TTL_MS = 60000; // bounds staleness from other users'/tabs' concurrent changes
  // On a cache miss, fetch this many pages' worth in one request instead of
  // just the one requested — sequential "next page" clicks then land in the
  // same already-fetched block and cost zero additional DB calls. Bigger
  // than Sales/Student's block size on purpose: for Fees the decrypt+
  // aggregate work happens once per call regardless of how many rows are
  // returned (LIMIT/OFFSET only trims the already-computed set), so a
  // larger block doesn't meaningfully add cost but does cut how often a
  // "Next" click has to cross a block boundary and hit the network.
  const PAGE_BLOCK_SIZE = 6;
  // The count query is a second full pass over the filter; skip it when
  // only the page/rowsPerPage changed within the same filter/search scope,
  // since the total can't have changed from that.
  const lastCountFilterKeyRef = React.useRef(null);

  const pageCacheKey = (filterKey, pageNum, size) => `${filterKey}|${pageNum}|${size}`;

  // Search refinement cache: when a search (within the current grade/
  // section/fee-slab/pending-fees filter) returns its *entire* matching set
  // in one go, it's remembered here. Typing more characters only ever
  // narrows the match, so as long as the other filters haven't changed and
  // the new search term still contains the cached one, we can filter that
  // already-fetched complete set in the browser instead of asking the
  // server again.
  const fullSearchCacheRef = React.useRef({ filterScopeKey: null, term: null, rows: [] });

  // Mirrors fn_get_student_fee_details_by_grade_slab_pending_fees's search
  // predicate: every word in the term must match SOME field, not
  // necessarily the same one, not the whole phrase as one literal substring
  // against a single field.
  const matchesFeesSearchTerm = (row, term) => {
    const words = term.toLowerCase().trim().split(/\s+/).filter(Boolean);
    const fields = [
      String(row.student_id ?? "").toLowerCase(),
      (row.first_name || "").toLowerCase(),
      (row.last_name || "").toLowerCase(),
      (row.father_name || "").toLowerCase(),
      (row.mother_name || "").toLowerCase(),
      (row.guardian_name || "").toLowerCase(),
      String(row.contact_no ?? "").toLowerCase(),
    ];
    return words.every((word) => fields.some((field) => field.includes(word)));
  };

  const getFeesReport = async (options = {}) => {
    // On first mount (and briefly after any hard refresh), academicYearId
    // is still "" — Layout resolves it asynchronously and only then sets
    // the real value. Fetching with the empty placeholder would render an
    // empty/wrong result that then gets replaced the moment the real year
    // arrives, which is exactly what shows up as a flicker. Skip the fetch
    // entirely until there's a real year to fetch for.
    if (!academicYearId) {
      return;
    }

    // Also scopes the search-refinement cache below — a different academic
    // year or sort is a different result set entirely, so it can't be
    // reused across years/sorts. academicYearId has to be in here too:
    // switching years doesn't clear appliedSearch, so without it the
    // refinement shortcut below would see the same search term and the
    // same grade/section/feeSlab/pendingFees/sort, judge the scope
    // "unchanged", and silently serve back the previous year's cached
    // rows for the new year — exactly the bug where searching, then
    // switching academic year, kept showing the old year's data until
    // the payment dialog was opened and closed (which force-refreshes).
    const filterScopeKey = `${academicYearId}|${appliedGradeId}|${appliedSectionId}|${appliedFeesSlabId}|${appliedPendingFees}|${orderBy}|${order}`;
    const filterKey = `${filterScopeKey}|${appliedSearch}`;
    const cacheKey = pageCacheKey(filterKey, page, rowsPerPage);
    const forceRefresh = options.forceRefresh === true;

    if (forceRefresh) {
      pageCacheRef.current.clear();
      fullSearchCacheRef.current = { filterScopeKey: null, term: null, rows: [] };
    } else {
      const cached = pageCacheRef.current.get(cacheKey);
      if (cached && Date.now() - cached.timestamp < PAGE_CACHE_TTL_MS) {
        setFeesReport(cached.rows);
        setDisplayedFeesReport(cached.rows);
        setTotalCount(cached.total);
        return; // served from memory — no request made
      }

      // Can this search be answered by narrowing an already-complete set?
      const priorCache = fullSearchCacheRef.current;
      if (
        appliedSearch &&
        priorCache.filterScopeKey === filterScopeKey &&
        priorCache.term !== null &&
        appliedSearch.toLowerCase().includes(priorCache.term.toLowerCase())
      ) {
        const filtered = priorCache.rows.filter((row) =>
          matchesFeesSearchTerm(row, appliedSearch)
        );
        const pageRows = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        setFeesReport(pageRows);
        setDisplayedFeesReport(pageRows);
        setTotalCount(filtered.length);
        // The filtered set is itself complete (a subset of a complete set
        // matching a more specific term), so refinement can keep chaining.
        fullSearchCacheRef.current = { filterScopeKey, term: appliedSearch, rows: filtered };
        lastCountFilterKeyRef.current = filterKey;
        pageCacheRef.current.set(cacheKey, {
          rows: pageRows,
          total: filtered.length,
          timestamp: Date.now(),
        });
        return; // served from memory — no request made
      }
    }

    setLoading(true);
    try {
      const skipCount = !forceRefresh && lastCountFilterKeyRef.current === filterKey;

      // Align the fetch to a block boundary and request the whole block.
      const blockIndex = Math.floor(page / PAGE_BLOCK_SIZE);
      const blockStartPage = blockIndex * PAGE_BLOCK_SIZE;
      const blockRowsPerPage = PAGE_BLOCK_SIZE * rowsPerPage;

      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/feesReport/getFeesReport",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            academic_year_id: academicYearId,
            grade_id: appliedGradeId ? appliedGradeId : null,
            fees_slab_id: appliedFeesSlabId ? appliedFeesSlabId : null,
            section_id: appliedSectionId ? appliedSectionId : null,
            pending_fees: appliedPendingFees ? true : false,
            page: blockIndex,
            rowsPerPage: blockRowsPerPage,
            search: appliedSearch || undefined,
            orderBy,
            order,
            skipCount,
          }),
        },
      );

      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return null; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      const blockRows = Array.isArray(data?.rows) ? data.rows : [];
      // total is null/undefined when skipCount was requested — keep the
      // existing totalCount rather than clobbering it with nothing.
      const effectiveTotal =
        data?.total !== null && data?.total !== undefined ? data.total : totalCount;
      if (data?.total !== null && data?.total !== undefined) {
        setTotalCount(data.total);
      }

      // Slice the block into individual pages and cache each one, so the
      // existing per-page lookup above transparently hits these on the
      // next few "next page" clicks.
      for (let i = 0; i < PAGE_BLOCK_SIZE; i++) {
        const subPage = blockStartPage + i;
        const subRows = blockRows.slice(i * rowsPerPage, (i + 1) * rowsPerPage);
        pageCacheRef.current.set(pageCacheKey(filterKey, subPage, rowsPerPage), {
          rows: subRows,
          total: effectiveTotal,
          timestamp: Date.now(),
        });
      }

      const requestedPageEntry = pageCacheRef.current.get(cacheKey);
      const pageRows = requestedPageEntry ? requestedPageEntry.rows : [];
      setFeesReport(pageRows);
      setDisplayedFeesReport(pageRows);

      // If this fetch turned out to cover the search's entire matching set
      // (small enough to fit in one block), remember it so further typing
      // can be refined client-side instead of hitting the server.
      if (data?.total !== null && data?.total !== undefined) {
        if (appliedSearch && data.total <= blockRowsPerPage) {
          fullSearchCacheRef.current = { filterScopeKey, term: appliedSearch, rows: blockRows };
        } else {
          fullSearchCacheRef.current = { filterScopeKey: null, term: null, rows: [] };
        }
      }
      if (!skipCount) {
        lastCountFilterKeyRef.current = filterKey;
      }
    } catch (error) {
      console.error("Error fetching fees report data:", error);
      setFeesReport([]);
      setDisplayedFeesReport([]);
      setTotalCount(0);
    } finally {
      setLoading(false); // Ensure loading is set to false when done
    }
  };

  // "Download Report" needs every matching student, not just the current
  // page, so it fetches separately rather than reusing the paginated
  // `rows` state.
  const fetchAllFeesReportForDownload = async () => {
    const response = await fetch(
      process.env.REACT_APP_JHS_DEVELOPMENT + "/feesReport/getFeesReport",
      {
        method: "POST",
        headers: { "Content-type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          academic_year_id: academicYearId,
          grade_id: appliedGradeId ? appliedGradeId : null,
          fees_slab_id: appliedFeesSlabId ? appliedFeesSlabId : null,
          section_id: appliedSectionId ? appliedSectionId : null,
          pending_fees: appliedPendingFees ? true : false,
          search: appliedSearch || undefined,
          orderBy,
          order,
          exportAll: true,
        }),
      },
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return Array.isArray(data?.rows) ? data.rows : [];
  };

  const handleChange = async (event, newValue) => {
    setValue(newValue);
  };

 const getGrades = async () => {
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/grade/getGrades", {
      method: "GET",
      headers: { "Content-type": "application/json" },
      credentials: "include",
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin");
          return null;
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          setGrades(data); 
        }
      })
      .catch((error) => {
        console.error("Error fetching grades:", error);
      });
  };

  const getFeesSlab = async () => {
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/fees/getFeeSlab", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ academic_year_id: academicYearId }),
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin");
          return;
        }
        return response.json();
      })
      .then((response) => {
        if (response) {
          const sorted = response.sort((a, b) =>
            a.fees_slab.localeCompare(b.fees_slab, undefined, {
              numeric: true,
              sensitivity: "base",
            }),
          );
          setFeesSlab(sorted);
        }
      })
      .catch((error) => {
        console.error("Error fetching fees slab:", error);
      });
  };

  function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (
      <Toolbar
        sx={{
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity,
              ),
          }),
        }}
      >
        {numSelected > 0 ? (
          <Typography
            sx={{ flex: "1 1 100%" }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            Nutrition
          </Typography>
        )}

        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Filter list">
            <IconButton>
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>
    );
  }

  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };

  useEffect(() => {
    if (feesReport.length > 0) {
      let selectedFeesPayment = feesReport.find(
        (fp) => fp.student_id === studentId,
      );
    }
  }, [studentId]);

  //Arohi
  //Added Sorting and Pagination
  // Sorting now happens server-side, across every matching student — not
  // just the page on screen (except "dues", see sortedRows below, which
  // comes from a separate prior-year fetch and stays client-side). A new
  // sort is effectively a different result order entirely, so this resets
  // to page 0.
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const mergedRows = useMemo(() => {
    return rows.map((row) => {
      const dueItem = dues.find((d) => d.student_id === row.student_id);
      return {
        ...row,
        dues: dueItem ? dueItem.due_amount : 0, // Default to 0 if no dues
      };
    });
  }, [rows, dues]);
  // Every sortable column except "dues" is now sorted server-side, across
  // every matching student, not just the page (see getFeesReport). "dues"
  // is the one exception: it comes from a separate previous-year fetch
  // (getDues) merged in above, entirely client-side, and isn't part of the
  // main paginated query — sorting by it can only ever cover the current
  // page. Every other column already arrives in the correct order, so
  // re-sorting here would be redundant at best; at worst a JS string
  // comparison could disagree with Postgres's collation and silently
  // undo the correct server order, so this only re-sorts for "dues".
  const sortedRows = useMemo(() => {
    if (orderBy !== "dues") {
      return mergedRows;
    }
    return [...mergedRows].sort((a, b) => {
      const valueA = parseFloat(a.dues) || 0;
      const valueB = parseFloat(b.dues) || 0;
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0;
    });
  }, [mergedRows, order, orderBy]);
  // `rows` is already a single server-paginated page (see getFeesReport),
  // so no further slicing by page/rowsPerPage happens here — doing so would
  // slice an already-small page a second time and blank out anything past
  // page 0.
  const paginatedRows = sortedRows;

  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    setFeesSlabId(0);
    // A payment may have just been recorded from one of the dialog's tabs,
    // changing pending/paid amounts server-side. Force the next fetch past
    // the page cache so the table doesn't keep showing pre-payment figures.
    getFeesReport({ forceRefresh: true });
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  // Function to navigate to the Refund tab (index 5)
  const navigateToRefundTab = () => {
    setValue(5); // Switch to Refund tab (index 5)
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleRowClick = (
    studentId, // student_id from the row
    firstName, // first_name from the row
    lastName, // last_name from the row
    feesSlab, // fees_slab from the row
    feesSlabId, // fees_slab_id from the row
    remarks, // remarks from the row
    refundBalance, // refund_amount from the row
    currentPendingAmount, // current_pending_amount from the row
    getGrade,
    getSection,
    transportSlabId,
    transportSlab,
  ) => {
    setStudentId(studentId);
    setStudentName(`${firstName} ${lastName}`);
    setFeesSlabId(feesSlabId);
    setFeesSlabAmount(feesSlab);
    setGetGrade(getGrade);
    setRemark(remarks);
    setRefundBalance(refundBalance);
    setCurrentPendingAmount(currentPendingAmount);
    setOpen(true); // Open your modal or dialog
    setGetSection(getSection);
    setTransportSlabId(transportSlabId);
    setTransportSlab(transportSlab);
  };

  const handleDownload = async (row) => {
    // The report covers every matching student, not just the page currently
    // displayed, so it fetches the full (unpaginated) result set on demand
    // rather than reusing the paginated `rows` state.
    let reportRows;
    try {
      reportRows = await fetchAllFeesReportForDownload();
    } catch (error) {
      console.error("Error fetching fees report data for report:", error);
      return;
    }

    // Prevent download if rows are empty or all rows contain no meaningful data
    const isDataEmpty =
      !reportRows ||
      reportRows.length === 0 ||
      reportRows.every(
        (row) =>
          !row.student_id &&
          !row.first_name &&
          !row.last_name &&
          !row.fees_slab &&
          !row.father_name &&
          !row.mother_name &&
          !row.guardian_name &&
          !row.contact_no &&
          !row.total_amount_paid &&
          !row.current_pending_amount,
      );

    if (isDataEmpty) {
      return;
    }

    const institute = getInstituteConfig(instituteId);

    const doc = new jsPDF();

    // Header background
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

    // Logo
    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 9, 1, 28, 18);
    }

    // School Name
    const textStartY = 11;
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text(institute.name, doc.internal.pageSize.getWidth() / 2, textStartY, {
      align: "center",
    });

    // Address
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1,
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" },
    );
    doc.text(
      institute.address2,
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 18,
      { align: "center" },
    );
    if (institute.tel) {
      doc.text(
        institute.tel,
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 22,
        { align: "center" },
      );
    }

    // Add Receipt Title, Number, and Date - Right aligned
    const receiptTextY = textStartY + 36; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "FEES MANAGEMENT REPORT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" },
    ); // Center aligned title
    doc.setFontSize(10);

    //Constants for alignment
    const studentLabelX = 14;
    const grade = `${gradeName || ""}`; // Grade name
    const feesSlab = `${feesSlabName || ""}`; // Fees slab amount
    const feesPending = `${pendingFees || ""}`; // Pending fees amount
    const section = `${sectionName || ""}`; // Section name

    // Constants for alignment and padding
    const pageWidth = doc.internal.pageSize.getWidth(); // Get the width of the PDF page
    const rightPadding = 14; // Padding from the right edge

    // Add Grade, Fees Slab, Pending Fees, and Section dynamically
    const studentDetailsY = receiptTextY + 10;

    // Set font for student name and details
    doc.setFont("helvetica", "bold");

    // Handle long student name (Grade)
    const gradeWidth = doc.getTextWidth(grade); // Get width of grade text
    const maxGradeWidth = 70; // Max width before wrapping
    const splitGrade =
      gradeWidth > maxGradeWidth
        ? doc.splitTextToSize(grade, maxGradeWidth)
        : grade;

    doc.text(`Grade: `, studentLabelX, studentDetailsY); // Left aligned
    doc.setFont("helvetica", "normal");
    doc.text(splitGrade, studentLabelX + 13, studentDetailsY); // Adjust X position for grade

    // Dynamically calculate X position for Fees Slab based on Grade length
    const gradeXEnd =
      studentLabelX +
      13 +
      (gradeWidth > maxGradeWidth ? maxGradeWidth : gradeWidth) +
      10; // End of grade text + 10 for padding

    // Set font and add Fees Slab
    doc.setFont("helvetica", "bold");
    doc.text("Fees Slab: ", gradeXEnd, studentDetailsY); // Start after grade
    doc.setFont("helvetica", "normal");
    const feesSlabWidth = doc.getTextWidth(feesSlab); // Calculate width of fees slab
    doc.text(feesSlab, gradeXEnd + 19, studentDetailsY); // Position fees slab with dynamic spacing

    // Dynamically calculate X position for Pending Fees based on Fees Slab length
    const feesSlabXEnd = gradeXEnd + 20 + feesSlabWidth + 10; // End of fees slab text + 10 for padding

    // Set font and add Pending Fees
    doc.setFont("helvetica", "bold");
    doc.text("Pending Fees: ", feesSlabXEnd, studentDetailsY); // Start after fees slab
    doc.setFont("helvetica", "normal");
    const pendingFeesWidth = doc.getTextWidth(feesPending); // Calculate width of pending fees
    doc.text(feesPending, feesSlabXEnd + 26, studentDetailsY); // Adjust X position for pending fees

    // Dynamically calculate X position for Section based on Pending Fees length
    const pendingFeesXEnd = feesSlabXEnd + 26 + pendingFeesWidth + 10; // End of pending fees text + 10 for padding

    // Set font and add Section
    doc.setFont("helvetica", "bold");
    doc.text("Section: ", pendingFeesXEnd, studentDetailsY); // Start after pending fees
    doc.setFont("helvetica", "normal");
    doc.text(section, pendingFeesXEnd + 15, studentDetailsY); // Adjust X position for section

    // --- Add Current Date on the Right Side ---
    // Get the current date
    const today = new Date();
    const currentDate = today.toLocaleDateString("en-GB"); // Format as DD-MM-YYYY

    // Set font for the "Date:" label
    doc.setFont("helvetica", "bold");

    // Get the width of the "Date:" label and the date text
    const dateLabel = "Date: ";
    const dateLabelWidth = doc.getTextWidth(dateLabel);
    const dateWidth = doc.getTextWidth(currentDate);

    // Calculate the X position for the date label (right aligned)
    const dateXPosition = pageWidth - rightPadding - dateWidth - dateLabelWidth; // Position the "Date:" label with padding from the right

    // Add the "Date:" label to the document
    doc.text(dateLabel, dateXPosition, studentDetailsY); // Add the "Date:" label

    // Set font to normal for the actual date
    doc.setFont("helvetica", "normal");
    doc.text(currentDate, dateXPosition + dateLabelWidth, studentDetailsY);
    // Calculate grand totals
    doc.setFont("helvetica", "bold");
    const totalAmountPaid = reportRows.reduce(
      (sum, row) => sum + row.total_amount_paid,
      0,
    );
    doc.setFont("helvetica", "bold");
    const totalAmountPending = reportRows.reduce(
      (sum, row) => sum + row.current_pending_amount,
      0,
    );

    doc.setFont("helvetica", "bold");
    const totalDues = reportRows.reduce(
      (sum, row) =>
        sum +
          dues.find((item) => item.student_id === row.student_id)?.due_amount ||
        0,
      0,
    );
    // Prepare table data
    const tableData = reportRows.map((row) => [
      row.student_id,
      `${row.first_name} ${row.last_name}`,
      row.fees_slab,
      `${row.father_name || ""} ${row.mother_name || ""} ${row.guardian_name || ""}`,
      row.contact_no,
      row.total_amount_paid,
      row.current_pending_amount,
      dues.find((item) => item.student_id === row.student_id)?.due_amount || 0,
    ]);

    // Add a row for the grand totals
    tableData.push([
      "", // Empty for Student ID
      "", // Label for the totals
      "", // Empty for Fees Slab
      "", // Empty for Parent Name
      "", // Grand total label
      "", // Total Amount Paid
      "", // Total Amount Pending
      "", // Dues label
    ]);
    tableData.push([
      "", // Empty for Student ID
      "", // Label for the totals
      "", // Empty for Fees Slab
      "", // Empty for Parent Name
      "Grand Total :", // Grand total label
      totalAmountPaid, // Total Amount Paid
      totalAmountPending, // Total Amount Pending
      totalDues, // Dues label
    ]);

    // Table settings
    doc.autoTable({
      head: [
        [
          "Student ID",
          "Student Name",
          "Fees Slab",
          "Parent Name",
          "Contact No",
          "Amount Paid",
          "Amount Pending",
          "Dues",
        ],
      ],
      body: tableData,
      startY: receiptTextY + 13, // Start table below receipt title
      styles: { fontSize: 8, halign: "center" },
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
      },
      theme: "grid",
      // Make the last row (Grand Total) bold
      didParseCell: (data) => {
        if (data.row.index === tableData.length - 1) {
          // Check if it's the last row
          data.cell.styles.fontStyle = "bold"; // Set font style to bold
        }
      },
    });
    // Save the PDF
    doc.save(
      `fees_management_report_${new Date().toISOString().slice(0, 10)}.pdf`,
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <Layout />
      <Dialog onClose={handleClose} maxWidth="xl" fullWidth open={open}>
        <DialogTitle></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ width: "auto" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label="Fee Payment"
                {...a11yProps(0)}
                style={{ marginLeft: "20px" }}
              />
              <Tab
                label="Store Purchase"
                {...a11yProps(1)}
                style={{ padding: "10px" }}
              />
              <Tab
                label="Store Payment"
                {...a11yProps(2)}
                style={{ padding: "10px" }}
              />
              <Tab
                label="Transport Payment"
                {...a11yProps(3)}
                style={{ padding: "10px" }}
              />
              <Tab
                label="Annual Subscription"
                {...a11yProps(4)}
                style={{ padding: "10px" }}
              />
              <Tab
                label="Refund"
                {...a11yProps(5)}
                style={{ padding: "10px" }}
              />
              <Tab
                label="Inventory Refund"
                {...a11yProps(6)}
                style={{ padding: "10px" }}
              />
              <Tab
                label="Payment Summary"
                {...a11yProps(7)}
                style={{ padding: "10px" }}
              />
            </Tabs>
          </Box>

          <CustomTabPanel value={value} index={0}>
            <FeePayment
              props={{
                studentId: studentId,
                feesSlabId: feesSlabId,
                studentName: studentName,
                feesSlabAmount: feesSlabAmount,
                currentPendingAmount: currentPendingAmount,
                remarks: remark,
                setRemark: setRemark,
                refundBalance: refundBalance,
                setRefundBalance: setRefundBalance,
                setCurrentPendingAmount: setCurrentPendingAmount,
                academicYearId: academicYearId,
                gradeName: getGrade,
                gradeId: gradeId,
                pendingFees: pendingFees,
                userId: userId,
                sectionName: getSection,
                sectionId: sectionId,
                userMail: userMail,
              }}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <StorePurchase
              props={{
                studentId: studentId,
                studentName: studentName,
                academicYearId: academicYearId,
                navigateToStorePayment: navigateToStorePayment,
              }}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <StorePayment
              props={{
                studentId: studentId,
                studentName: studentName,
                refundBalance: refundBalance,
                setRefundBalance: setRefundBalance,
                academicYearId: academicYearId,
                gradeName: getGrade,
                userId: userId,
                gradeId: gradeId,
                feesSlabId: feesSlabId,
                pendingFees: pendingFees,
                sectionName: getSection,
                sectionId: sectionId,
                userMail: userMail,
              }}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <TransportPayment
              props={{
                studentId: studentId,
                studentName: studentName,
                refundBalance: refundBalance,
                setRefundBalance: setRefundBalance,
                academicYearId: academicYearId,
                gradeName: getGrade,
                userId: userId,
                gradeId: gradeId,
                feesSlabId: feesSlabId,
                pendingFees: pendingFees,
                sectionName: getSection,
                sectionId: sectionId,
                transportSlabId: transportslabId,
                transportSlab: transportSlab,
                userMail: userMail,
              }}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <AnnualSubscription
              props={{
                studentId: studentId,
                studentName: studentName,
                refundBalance: refundBalance,
                setRefundBalance: setRefundBalance,
                academicYearId: academicYearId,
                gradeName: getGrade,
                userId: userId,
                gradeId: gradeId,
                feesSlabId: feesSlabId,
                pendingFees: pendingFees,
                sectionName: getSection,
                sectionId: sectionId,
                userMail: userMail,
              }}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={5}>
            <Refund
              props={{
                studentName: studentName,
                studentId: studentId,
                academicYearId: academicYearId,
                gradeName: getGrade,
                userId: userId,
                sectionName: getSection,
                sectionId: sectionId,
                userMail: userMail,
              }}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={6}>
            <InventoryRefund
              props={{
                studentName: studentName,
                studentId: studentId,
                refundBalance: refundBalance,
                academicYearId: academicYearId,
                userId: userId,
                navigateToRefundTab: navigateToRefundTab,
              }}
              // Pass the function to InventoryRefund
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={7}>
            <PaymentSummary
              props={{
                studentName: studentName,
                studentId: studentId,
                refundBalance: refundBalance,
                gradeName: getGrade,
                currentPendingAmount: currentPendingAmount,
                academicYearId: academicYearId,
                gradeId: gradeId,
                feesSlabId: feesSlabId,
                pendingFees: pendingFees,
                setRefundBalance: setRefundBalance,
                sectionName: getSection,
                sectionId: sectionId,
              }}
            />
          </CustomTabPanel>
        </Box>
      </Dialog>
      <div>
        <h1 className="fees_management_title"> Fees Management</h1>
      </div>
      <Stack spacing={2} direction="row" mb={2}>
        <Button
          variant="contained"
          className="save_update_btn"
          onClick={() => {
            navigate("/fees-report");
          }}
        >
          Fees
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            navigate("/fees-slab");
          }}
        >
          Fees Slab
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            navigate("/kit-payment-management");
          }}
        >
          Kit Payment
        </Button>
      </Stack>
      {/* <br /> */}
      <div className="fees_report_box">
        <Stack spacing={4} direction="row">
          <Stack direction="row" spacing={2} alignItems="center">
            {" "}
            {/* Align items vertically centered */}
            {/* Search Box */}
            <Box component="form" className="search-box" style={{ marginRight: "-6px" }}>
              <TextField
                label="Search..."
                variant="outlined"
                fullWidth
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                onKeyDown={handleSearchKeyDown}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        type="button"
                        sx={{ p: "10px" }}
                        aria-label="search"
                        onClick={handleApplyFilters}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment: search ? (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        sx={{ p: "6px" }}
                        aria-label="clear search"
                        onClick={handleClearSearch}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
              />
            </Box>
            {/* Grade Select with filter */}
            <Box sx={{ minWidth: 265 }} style={{ marginRight: "-6px" }}>
              <Autocomplete
                size="small"
                fullWidth
                options={[{ grade_id: "", grade_name: "All" }, ...grades]}
                getOptionLabel={(option) => option.grade_name}
                isOptionEqualToValue={(option, value) => option.grade_name === value.grade_name}
                value={
                  gradeName === ""
                    ? { grade_id: "", grade_name: "All" }
                    : grades.find((g) => g.grade_name === gradeName) || null
                }
                onChange={(event, newValue) => {
                  handleGradeChange({
                    target: {
                      value: newValue && newValue.grade_id !== "" ? newValue.grade_name : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Grade"
                    inputProps={{
                      ...params.inputProps,
                      style: {
                        textOverflow: "clip",
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.grade_name
                      .toLowerCase()
                      .includes(inputValue.toLowerCase()),
                  );
                }}
                noOptionsText="No matching grades"
                openOnFocus={false}
                clearOnEscape
                disableClearable
              />
            </Box>
            {/* Section Select */}
            <Box sx={{ minWidth: 100 }} style={{ marginRight: "-6px" }}>
              <FormControl sx={{ minWidth: 100 }} size="small">
                <InputLabel id="demo-simple-select-label" shrink>Section</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={sectionName}
                  label="Section"
                  onChange={handleSectionChange}
                  displayEmpty
                >
                  <MenuItem value="">All</MenuItem>
                  {sections.map((g) => (
                    <MenuItem key={g.section_name} value={g.section_name}>
                      {g.section_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {/* Fee Slab Select */}
            <Box sx={{ minWidth: 100 }} style={{ marginRight: "-6px" }}>
              <FormControl sx={{ minWidth: 100 }} size="small">
                <InputLabel id="demo-simple-select-label" shrink>Fee Slab</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={feesSlabName}
                  label="Fee Slab"
                  onChange={handleFeesSlabChange}
                  displayEmpty
                >
                  <MenuItem value="">All</MenuItem>
                  {feesSlab.map((fs) => (
                    <MenuItem key={fs.fees_slab} value={fs.fees_slab}>
                      {fs.fees_slab}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Stack className="pending-fees-switch" style={{ marginRight: "-6px" }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={pendingFees}
                    onChange={handlePendingFeesChange}
                  />
                }
                label="Pending Fees"
              />
            </Stack>
            <Button
              onClick={handleApplyFilters}
              style={{
                background: "#0A64A2",
                color: "#fff",
                marginLeft: "4px",
                minWidth: "auto",
                paddingTop: "6px",
                paddingBottom: "6px",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              Go
            </Button>
          </Stack>
          <Box className="download-report-box-fees-report">
            <Button
              className="fees_report_btn"
              variant="contained"
              onClick={handleDownload}
              startIcon={<DownloadIcon />}
            >
              Download Report
            </Button>
          </Box>
        </Stack>
      </div>
      {/* <br /> */}

      <Box className="table-container">
        <Box className="table-container">
          <Paper className="table-container-paper">
            <TableContainer component={Paper} style={{ position: "relative" }}>
              {/* Small, out-of-the-way "still working" cue — rows below
                  stay at full opacity (no dim/blur) the whole time, this is
                  the only loading signal for a refetch (sort, page change,
                  filter). */}
              {loading && paginatedRows.length > 0 && (
                <CircularProgress
                  size={20}
                  style={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
                />
              )}
              <Table
                sx={{ minWidth: 750 }}
                aria-label="custom pagination table"
              >
                <TableHead align="center">
                  <TableRow>
                    <StyledTableCell
                      sortDirection={orderBy === "student_id" ? order : false}
                      align="center"
                      className="fees_report_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "student_id"}
                        direction={orderBy === "student_id" ? order : "asc"}
                        onClick={() => handleRequestSort("student_id")}
                      >
                        Student ID
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      sortDirection={orderBy === "first_name" ? order : false}
                      align="center"
                      className="fees_report_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "first_name"}
                        direction={orderBy === "first_name" ? order : "asc"}
                        onClick={() => handleRequestSort("first_name")}
                      >
                        Student Name
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ paddingLeft: "28px" }}
                    >
                      <TableSortLabel
                        active={orderBy === "fees_slab"}
                        direction={orderBy === "fees_slab" ? order : "asc"}
                        onClick={() => handleRequestSort("fees_slab")}
                      >
                        Fees Slab{" "}
                        {selectedYear === currentAcademicYear
                          ? ""
                          : `(${selectedYear})`}
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      sortDirection={
                        orderBy === "guardian_name" ? order : false
                      }
                      align="center"
                      style={{ paddingLeft: "25px" }}
                    >
                      <TableSortLabel
                        active={orderBy === "guardian_name"}
                        direction={orderBy === "guardian_name" ? order : "asc"}
                        onClick={() => handleRequestSort("guardian_name")}
                      >
                        Parent Name
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ paddingLeft: "34px" }}
                    >
                      <TableSortLabel
                        active={orderBy === "contact_no"}
                        direction={orderBy === "contact_no" ? order : "asc"}
                        onClick={() => handleRequestSort("contact_no")}
                      >
                        Contact No
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ paddingLeft: "30px" }}
                    >
                      <TableSortLabel
                        active={orderBy === "total_amount_paid"}
                        direction={
                          orderBy === "total_amount_paid" ? order : "asc"
                        }
                        onClick={() => handleRequestSort("total_amount_paid")}
                      >
                        Amount Paid
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <TableSortLabel
                        active={orderBy === "current_pending_amount"}
                        direction={
                          orderBy === "current_pending_amount" ? order : "asc"
                        }
                        onClick={() =>
                          handleRequestSort("current_pending_amount")
                        }
                      >
                        Amount Pending
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ paddingLeft: "30px" }}
                    >
                      <TableSortLabel
                        active={orderBy === "dues"}
                        direction={orderBy === "dues" ? order : "asc"}
                        onClick={() => handleRequestSort("dues")}
                      >
                        Dues *
                      </TableSortLabel>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                {/* Show a spinner only for a genuine first load; a refetch
                    (cache miss on filter/page change) keeps the previous
                    rows visible at full opacity (no dim/blur) — the small
                    corner spinner above is the only loading cue then,
                    instead of flashing to blank. */}
                {(loading || !academicYearId) && paginatedRows.length === 0 ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {paginatedRows.map((row) => (
                      <StyledTableRow
                        style={{ cursor: "pointer", textAlign: "center" }}
                        key={row.student_id}
                        onClick={() =>
                          handleRowClick(
                            row.student_id,
                            row.first_name,
                            row.last_name,
                            row.fees_slab,
                            row.fees_slab_id,
                            row.remarks,
                            row.refund_amount,
                            row.current_pending_amount,
                            row.grade_name,
                            row.section_name,
                            row.transport_slab_id,
                            row.transport_slab_amount,
                          )
                        }
                        tabIndex={-1}
                        padding="none"
                      >
                        <StyledTableCell
                          component="th"
                          scope="row"
                          padding="none"
                          align="center"
                          className="table_content"
                        >
                          {row.student_id}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ paddingLeft: "0" }}
                        >
                          {row.first_name} {row.last_name}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.fees_slab}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.father_name
                            ? row.father_name
                            : row.mother_name || row.guardian_name}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.contact_no}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.total_amount_paid}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.current_pending_amount}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {dues.find(
                            (item) => item.student_id === row.student_id,
                          )?.due_amount || 0}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                )}
                <TableFooter className="table-footer">
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="td"
                      count={totalCount}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      className="table-pagination"
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Box>
      <Typography
        variant="body2"
        style={{ marginTop: "10px", textAlign: "left", fontWeight: "bold" }}
      >
        * Pending Fees from previous academic year.
      </Typography>
    </div>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
